import { User } from '@/lib/types/UserT'
import { cn } from '@/lib/utils'
import Avatar from '@/components/livecontact/Avatar'
import LcIcon from '@/components/livecontact/icons'
import { CHIP_CLASS, CHIP_REMOVE_CLASS } from '@/components/livecontact/fieldStyles'

/** Selected-user chip: 18px avatar, name, remove. */
const UserTag = ({ user, onRemove }: { user: User; onRemove: (id: number) => void }) => {
  const fullName = `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim() || user.email

  return (
    <span className={cn(CHIP_CLASS, 'pl-1 animate-lc-pop')}>
      <Avatar name={fullName} size={18} />
      <span className="max-w-[160px] truncate">{fullName}</span>
      <button
        type="button"
        onClick={() => onRemove(user.id)}
        aria-label={`Remove ${fullName}`}
        className={CHIP_REMOVE_CLASS}
      >
        <LcIcon name="close" size={12} />
      </button>
    </span>
  )
}

export default UserTag
